export type AdminTheme = {
  pageBg: string;
  cardBg: string;
  border: string;
  text: string;
  subText: string;
  inputBg: string;
  hoverBg: string;
  primary: string;
  danger: string;
  success: string;
  warning: string;
  radius: number;
};

// Match the existing app's visual language (see `src/components/ControlPanel.tsx`).
export const getAdminTheme = (isDarkMode: boolean): AdminTheme => {
  if (isDarkMode) {
    return {
      pageBg: '#111827',
      cardBg: '#1F2937',
      border: '#374151',
      text: '#F9FAFB',
      subText: '#D1D5DB',
      inputBg: '#374151',
      hoverBg: '#111827',
      primary: '#3B82F6',
      danger: '#EF4444',
      success: '#10B981',
      warning: '#F59E0B',
      radius: 8,
    };
  }

  return {
    pageBg: '#F9FAFB',
    cardBg: '#FFFFFF',
    border: '#D1D5DB',
    text: '#111827',
    subText: '#374151',
    inputBg: '#FFFFFF',
    hoverBg: '#F3F4F6',
    primary: '#2563EB',
    danger: '#EF4444',
    success: '#10B981',
    warning: '#F59E0B',
    radius: 8,
  };
};
